(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

/*
* Validates cart by checking for clashing or restricted product tags
*/
const validateCart = () => {
  const productsInCart = [...document.querySelectorAll('.cart-table > .item')];
  const checkoutButton = document.querySelector('#cart-checkout-button');
  const reserveButton = document.querySelector('.reserveInStore-btn');
  const reserveButtonContainer = document.querySelector('.reserveInStore-btn-container');
  const cartMessage = document.querySelector('.cart-validation-message');
  const additionalButtons = document.querySelector('.additional-checkout-buttons');

  if(reserveButtonContainer) {
    reserveButtonContainer.classList.add('disabled');
    reserveButton.disabled = true;
  }

  const validation = productsInCart.map(product => {
    return checkProductTags(product);
  });

  cartMessage.innerText = '';

  if (validation.includes('notAvailable')) {
    cartMessage.classList.add('error');
    cartMessage.innerText = 'Sorry, you cannot checkout as your basket contains items that are not available. Please remove these items to continue with your order.';
    applyErrorMessages();
  } else if (validation.includes('availableFindStore')) {
    cartMessage.classList.add('error');
    cartMessage.innerText = 'Sorry, you cannot checkout as your basket contains items that are not available for delivery or in store collection. Please remove these items to continue with your order.';
    applyErrorMessages();
  } else if ((validation.includes('availableInStore') && validation.includes('availableOnline'))
          || (validation.includes('availableInStore') && validation.includes('availableOnline') && validation.contains('availableInStoreOnline'))) {
    cartMessage.innerText = 'Sorry, you cannot checkout as your basket contains a mix of delivery and in store collection products.';
    applyErrorMessages();
  } else if (validation.includes('availableInStore') && validation.includes('availableInStoreOnline')) {
    cartMessage.innerText = 'Sorry, you cannot checkout for delivery as some of the items in your basket are not available for home delivery.';
    reserveButtonContainer.classList.remove('disabled');
    reserveButton.disabled = false;
    applyErrorMessages();
  } else if (validation.includes('availableOnline') && validation.includes('availableInStoreOnline')) {
    cartMessage.innerText = 'Sorry, Reserve in store is not available as some of the items in your basket are not available for reserve and collect.';
    checkoutButton.classList.remove('disabled');
    checkoutButton.disabled = false;
    if (additionalButtons) additionalButtons.classList.remove('hidden');
    applyErrorMessages();
  } else if (validation.includes('availableInStoreOnline')) {
    checkoutButton.classList.remove('disabled');
    checkoutButton.disabled = false;
    reserveButtonContainer.classList.remove('disabled');
    reserveButton.disabled = false;
    if (additionalButtons) additionalButtons.classList.remove('hidden');
  } else if (validation.includes('availableInStore')) {
    reserveButtonContainer.classList.remove('disabled');
    reserveButton.disabled = false;
    checkoutButton.classList.add('hidden');
    if (additionalButtons) additionalButtons.classList.add('hidden');
  } else if (validation.includes('availableOnline')) {
    checkoutButton.classList.remove('disabled');
    checkoutButton.disabled = false;
    reserveButtonContainer.classList.add('hidden');
    if (additionalButtons) additionalButtons.classList.remove('hidden');
  }
};

/*
* Checks product classes for tags and returns a category for that product
*/
const checkProductTags = (product) => {
  const productMessage = product.querySelector('.product-validation-message');

  if(!product.classList.contains('tag-available-findstore') && !product.classList.contains('tag-available-instore') && !product.classList.contains('tag-available-online')) {
    return 'notAvailable';
  } else if(product.classList.contains('tag-available-findstore')) {
    return 'availableFindStore';
  } else if(product.classList.contains('tag-available-instore') && product.classList.contains('tag-available-online')) {
    return 'availableInStoreOnline';
  } else if(product.classList.contains('tag-available-instore') && !product.classList.contains('tag-available-online')) {
    return 'availableInStore';
  } else if(!product.classList.contains('tag-available-instore') && product.classList.contains('tag-available-online')) {
    return 'availableOnline';
  }
};

/*
* Applies error messages when needed
*/
const applyErrorMessages = () => {
  const products = [...document.querySelectorAll('.cart-table > .item')];

  products.forEach(product => {
    const productMessage = product.querySelector('.product-validation-message');
    
    if(!product.classList.contains('tag-available-findstore') && !product.classList.contains('tag-available-instore') && !product.classList.contains('tag-available-online')) {
      product.classList.add('error');
      productMessage.innerText = 'Sorry, this product is no longer available.';
    } else if(product.classList.contains('tag-available-findstore')) {
      product.classList.add('error');
      productMessage.innerText = 'Not available for delivery or in store collection';
    } else if(product.classList.contains('tag-available-instore') && product.classList.contains('tag-available-online')) {
      return 'availableInStoreOnline';
    } else if(product.classList.contains('tag-available-instore') && !product.classList.contains('tag-available-online')) {
      productMessage.innerText = 'Only Available for Reserve and Collect';
    } else if(!product.classList.contains('tag-available-instore') && product.classList.contains('tag-available-online')) {
      productMessage.innerText = 'Only available for Home Delivery';
    }
  });
};

/*
* Add event listeners to update when cart quantity is adjusted
*/
const attachCartValidationEventListeners = () => {
  document.addEventListener('shopify-cart-updated', validateCart);
}

/*
* Make sure the reservations plugin has loaded and is visible before validation
*/
const reserveButton = document.querySelector('.reserveInStore-btn');
  
if(reserveButton) {
 validateCart();
 attachCartValidationEventListeners();
  
 reserveButton.hide();  // Remove the button from the DOM

  
} else {
   reserveButton.hide();  // Remove the button from the DOM

  const cartButtonContainer = document.querySelector('.cart-checkout-button-container');
  const reserveObserverConfig = {childList: true};

  const checkForReserveButton = (mutationList, reserveObserver) => {
    for(const mutation of mutationList) {
      if(mutation.type === 'childList') {
        if(cartButtonContainer.querySelector('.reserveInStore-btn')) {
          reserveObserver.disconnect();

          const risExistsEvent = new CustomEvent('risExists');
          window.dispatchEvent(risExistsEvent);

          validateCart();
          attachCartValidationEventListeners();
        };
      }
    }
  }
  const reserveObserver = new MutationObserver(checkForReserveButton);  
  reserveObserver.observe(cartButtonContainer, reserveObserverConfig);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-carousel"] && !window.DesignMode) return;
  try {
    

const featureCarousels = [...document.querySelectorAll('.feature-carousel')];

featureCarousels.forEach(carousel => {

  const { desktopSlides, tabletSlides, mobileSlides, spaceBetweenSlides, autoplaySlides, autoplaySpeed, animationSpeed, loopSlides } = carousel.dataset;
  const slideCount = carousel.querySelectorAll('.feature-carousel__slide');
  const autoplaySettings = autoplaySlides !== 'false' ? { delay: autoplaySpeed * 1000 } : false;
  const loopSettings = autoplaySlides === 'true' ? true : false;
  
  const prev = carousel.querySelector('.swiper-button-prev');
  const next = carousel.querySelector('.swiper-button-next');

  const swiper = new Swiper(carousel, {
    a11y: true,
    autoplay: autoplaySettings,
    spaceBetween: Number(spaceBetweenSlides),
    speed: animationSpeed * 100,
    slidesPerView: mobileSlides,
    loop: slideCount <= mobileSlides ? loopSettings : false,
    watchOverflow: true,

    // responsive breakpoints
    breakpoints: {
      425: {
        slidesPerView: tabletSlides,
        loop: slideCount <= tabletSlides ? loopSettings : false,
      },
      1024: {
        slidesPerView: desktopSlides,
        loop: slideCount <= desktopSlides ? loopSettings : false,
      }
    },

    updateOnImagesReady: true,
    CSSWidthAndHeight: true,

    // Navigation arrows
    navigation: {
      nextEl: next,
      prevEl: prev,
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup-modal"]) return;
  try {
    
const readCookie = (name) => {
  const cookieArray = document.cookie.split(';');

  if (cookieArray.length < 1) {
    return null;
  }

  for (let i = 0; i < cookieArray.length; i += 1) {
    const cookieItem = cookieArray[i].split('=');
    if (cookieItem[0].replace(/\s/g, '') === name) {
      return cookieItem[1];
    }
  }
  return null;
};

const checkForCookie = (name) => {
  return readCookie(name) !== null;
};

const createCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  } else {
    expires = '';
  }
  document.cookie = `${name}=${value}${expires};`;
};

const deleteCookie = (name) => {
  createCookie(name, '', -1);
};

const getUrlParameter = (sParam) => {
  function decode(s) {
    return decodeURIComponent((s || '').replace(/\+/g, ' '));
  }

  const sPageURL = window.location.search.substring(1);
  const sURLVariables = sPageURL.split('&');

  for (let i = 0; i < sURLVariables.length; i += 1) {
    const sParameterSplit = sURLVariables[i].split('=');
    if (decode(sParameterSplit[0]) === sParam) {
      return decode(sParameterSplit[1]);
    }
  }

  return null;
};



document.addEventListener('DOMContentLoaded', () => {

  const visitorChannel = getUrlParameter('channel');
  const isMember = checkForCookie('tofs_member');
  const closedModal = checkForCookie('newsletter_closed');
  const modalElement = document.getElementById('newsletter-modal');
  const countdown = parseInt(modalElement.getAttribute('data-countdown')) * 1000;

  if (isMember) {
    return;
  } else {
    if (visitorChannel !== 'crm') {
      if (closedModal) {
        return;
      }

      setTimeout(() => {
        MicroModal.show('newsletter-modal', {
          onClose: () => createCookie('newsletter_closed', true, 30)
        });
      }, countdown);
    } else {
      createCookie('tofs_member', true, 30);
    }
  }
});

  } catch(e) { console.error(e); }
})();
      })();
